import Util from '../../lib/utils';
import Vue from 'vue';
import { Store, Module, ActionContext } from 'vuex';
import Vuex from 'vuex';
import Ajax from '../../lib/ajax';
Vue.use(Vuex);
import OrderMan from '../entities/orderman';
import GoodsForCart from '../entities/goodsforcart';
interface CartState {
    goodsList: GoodsForCart[];
    orderman: OrderMan;
    pickupinstore: any;
    orderConfirmVoucher: any;
    orderFreight: any;
    voucheramt: number;
    addDistance: number;
    scorecosts: number;
    selectscore: number;
    morenVoucher: any;
    buyFullPromotionList: Array<any>;
    currentActivityType: string;//活动类型  miaosha-秒杀    pintuan-拼团  preorder-预购
    pintuanData: any;//拼团数据
    discountType: string;
    discount: string;
    ordermemo: string;
    currentActivityDealDate: string;
    goodsWeight: any;
    freightRegions: any;
    freightDistances: any;
    freightFlag: any;
    currentFreightRegion: any;
    dealtime: any;
    dealtime_text: any;
    currentDealType: 2,
    cartNum: 1,
    buyFullPromotionItems: Array<any>;
    marketOpenofflinediscount:string;
    javaGoodNotVoucher:Array<string>;
}

class CartModule implements Module<CartState, any> {
    enshopid = Util.siss.auth.getenshopid();
    public state = {
        goodsList: localStorage[this.enshopid + '_goodsList'] ? JSON.parse(localStorage[this.enshopid + '_goodsList']) : [],
        orderman: localStorage[this.enshopid + '_orderman'] ? JSON.parse(localStorage[this.enshopid + '_orderman']) : new OrderMan(),
        pickupinstore: localStorage[this.enshopid + '_orderConfirmBranch'] ? JSON.parse(localStorage[this.enshopid + '_orderConfirmBranch']) : {},
        orderConfirmVoucher: sessionStorage.orderConfirmVoucher ? JSON.parse(sessionStorage.orderConfirmVoucher) : {},
        orderFreight: {},
        voucheramt: 0,
        addDistance: -1,
        scorecosts: 0,
        selectscore: 0,
        morenVoucher: {},
        buyFullPromotionList: [],
        currentGoodsList: [],//立即结算商品
        currentActivity: {},//当前活动
        currentActivityType: "",//活动类型  miaosha-秒杀    pintuan-拼团 preorder-预购
        pintuanData: {},
        discountType: sessionStorage.discountType ? sessionStorage.discountType : 0,
        discount: sessionStorage.discount ? sessionStorage.discount : 1,
        ordermemo: '',
        currentActivityDealDate: '',
        freightRegions: [],
        freightDistances: [],
        goodsWeight: [],
        goodsNotdiscount:[],
        freightFlag: 0,//0：在配送范围或区域内，并且运费计算成功 -1：不在配送范围内或区域内 -2：地图加载失败，无法计算 -3:收货地址city信息为空
        currentFreightRegion: {},
        dealtime: '',
        dealtime_text: ',',
        buyFullPromotionItems: [],
        marketOpenofflinediscount:'',
        javaGoodNotVoucher:[],
        kanjiaOrder: '',
        addPriceList: localStorage[this.enshopid + '_addPriceList'] ? JSON.parse(localStorage[this.enshopid + '_addPriceList']) : []
    };
    public getters = {
        currentsum: (state) => {
            let total = 0;
            state.currentGoodsList.forEach((item) => {
                total += item.Price * item.Count;
            });
            return total;
        },
        confirmcurrentSum: (state) => {//立即计算商品金额
            let total = 0;
            state.currentGoodsList.forEach((item) => {
                total += item.Price * item.Count;
            });
            state.voucheramt = 0;
            let _favourablesumCurrent = this.getters.favourablesumCurrent(state);
            if (_favourablesumCurrent) {
                total -= _favourablesumCurrent || 0;
            }
            let activityId = state.currentGoodsList.length == 0 ? null : state.currentGoodsList[0].ActivityId;
            let isUseVoucher = state.currentActivity.isUseVoucher;
            let isUseFreight = state.currentActivity.isUseFreight;
            if (state.discountType == 1) {//线下折扣,则不计算优惠券
                total -= this.getters.discountamtCurrent(state) || 0;
            }
            else {
                if (activityId == null || (activityId != null && isUseVoucher == true)) {
                    let _voucheramtCurrent = this.getters.voucheramtCurrent(state);
                    if (_voucheramtCurrent) {
                        total -= _voucheramtCurrent || 0;
                    }
                }
            }
            if (activityId == null || (activityId != null && isUseFreight == true)) {
                let _transFeeCurrent = this.getters.transFeeCurrent(state);
                if (_transFeeCurrent) {
                    total += _transFeeCurrent || 0;
                }
            }
            if (state.scorecosts * 1 > 0) {
                total -= state.scorecosts * 1;
            }
            if (total <= 0) {
                total = 0.01;
            }
            return total;
        },
        currentoldsum: (state) => {
            let total = 0;
            state.currentGoodsList.forEach((item) => {
                if (item.Checked) {
                    total += item.OldPrice * item.Count;
                }
            });
            return total;
        },
        sum: (state) => {
            let total = 0;
            state.goodsList.forEach((item) => {
                if (item.Checked) {
                    total += item.Price * item.Count;
                }
            });
            state.addPriceList.forEach((item) => {
              item.addPriceGoods.map(data => {
                total += data.Price * data.Count;
              })
            });
            return total;
        },
        oldsum: (state) => {
            let total = 0;
            state.goodsList.forEach((item) => {
                if (item.Checked) {
                    total += item.OldPrice * item.Count;
                }
            });
            state.addPriceList.forEach((item) => {
              item.addPriceGoods.map(data => {
                total += data.OldPrice * data.Count;
              })
            });
            return total;
        },
        confirmsum: (state) => {
            let total = this.getters.sum(state) || 0;
            let itemtotal = total;
            let _favourablesum = this.getters.favourablesum(state);
            if (_favourablesum) {
                total -= _favourablesum || 0;
            }
            let _voucheramt = this.getters.voucheramt(state);
            if (_voucheramt) {
                total -= _voucheramt || 0;
            } else if (state.discountType == 1) {
                total -= this.getters.discountamt(state) || 0;
            }
            if (state.scorecosts * 1 > 0) {
                total -= state.scorecosts * 1;
            }
            let _transFee = this.getters.transFee(state);
            if (_transFee) {
                total += _transFee || 0;
            }
            if (total <= 0 && itemtotal > 0) {
                total = 0.01;
            }
            return total;
        },
        favourablesum: (state) => {
            let total: number = 0;
            let selectgoodsList: Array<any> = state.goodsList.filter(item => item.Checked);
            state.buyFullPromotionList.forEach((item) => {
                let groupfeetoatl: number = 0;
                let groupnumtoatl: number = 0;
                selectgoodsList.forEach((item2) => {
                    if (item.itemno.indexOf(item2.No) > -1) {
                        groupfeetoatl += item2.Price * item2.Count;
                        groupnumtoatl += item2.Count;
                    }
                });
                for (let i: number = 0; i < item.rules.length; i++) {
                    let rule: any = item.rules[i];
                    if ((rule.thresholdtype == "1" && groupfeetoatl >= rule.thresholdprice) ||
                        (rule.thresholdtype == "2" && groupnumtoatl >= rule.thresholdnum)) {
                        if (rule.isreduceprice) {
                            total += rule.reduceprice ? rule.reduceprice : 0;
                        }
                        break;
                    }
                }
            });
            let itemtotal = this.getters.sum(state) || 0;
            total = total >= itemtotal ? itemtotal : total;
            return total;
        },
        favourabletotal: (state) => {
            let total: number = 0;
            let selectgoodsList: Array<any> = state.goodsList.filter(item => item.Checked);
            state.buyFullPromotionList.forEach((item) => {
                let groupfeetoatl: number = 0;
                let groupnumtoatl: number = 0;
                selectgoodsList.forEach((item2) => {
                    if (item.itemno.indexOf(item2.No) > -1) {
                        groupfeetoatl += item2.Price * item2.Count;
                        groupnumtoatl += item2.Count;
                    }
                });
                for (let i: number = 0; i < item.rules.length; i++) {
                    let rule: any = item.rules[i];
                    if ((rule.thresholdtype == "1" && groupfeetoatl >= rule.thresholdprice) ||
                        (rule.thresholdtype == "2" && groupnumtoatl >= rule.thresholdnum)) {
                        total += groupfeetoatl ? groupfeetoatl : 0;
                        break;
                    }
                }
            });
            return total;
        },
        notdiscountTotal:(state)=>{
            ///折扣例外商品总价
            ///首先要判断例外商品是否在满减商品里，如果在则继续判断是否满减使用线下折扣，使用的话要把满减的金额减去，不使用的话则直接累加商品价格
            let total = 0;
            let buyFullTotal=0;
            let buyFullReduceTotal=0;
            let selectgoodsList: Array<any> = state.goodsList.filter(item => item.Checked);
            let hasBuyFullItemnos=[];//满足满减条件的商品编号数组
            let notInItmenos=[];//不满足满减条件的例外商品编号数组
            state.buyFullPromotionList.forEach((item) => {
                let groupfeetoatl: number = 0;
                let groupnumtoatl: number = 0;
                selectgoodsList.forEach(item2 => {
                    if(item.itemno.indexOf(item2.No)>-1){
                        groupfeetoatl += item2.Price * item2.Count;
                        groupnumtoatl += item2.Count;
                        for (let i: number = 0; i < item.rules.length; i++) {
                            let rule: any = item.rules[i];
                            if ((rule.thresholdtype == "1" && groupfeetoatl >= rule.thresholdprice) ||
                                (rule.thresholdtype == "2" && groupnumtoatl >= rule.thresholdnum)) {
                                if (rule.isreduceprice) {
                                    buyFullReduceTotal += rule.reduceprice ? rule.reduceprice : 0;
                                }
                                buyFullTotal += groupfeetoatl ? groupfeetoatl : 0;
                                hasBuyFullItemnos.push(item2.No);
                                break;
                            }
                        }
                    }
                });
            });
            if(state.buyFullPromotionList.length==0 || hasBuyFullItemnos.length == 0){
                notInItmenos=state.goodsNotdiscount;
            }else{
                state.goodsNotdiscount.forEach(element => {
                    if((hasBuyFullItemnos.indexOf(element)==-1) && (notInItmenos.indexOf(element)==-1)){
                        notInItmenos.push(element)
                    }
                });
            }
            if(buyFullTotal>0){
                if(state.marketOpenofflinediscount &&state.marketOpenofflinediscount.indexOf('4')>-1){
                    total = buyFullReduceTotal;
                }else{
                    total = buyFullTotal;
                }
            }
            selectgoodsList.forEach((item2) => {
                if (notInItmenos.indexOf(item2.No) > -1) {
                    total += item2.Price * item2.Count;
                }
            });
            return total;
        },
        voucheramt: (state) => {
            //return  state.voucheramt || 0;
            let _voucheramt = 0;
            let total = this.getters.sum(state) || 0;
            let javaGoodNotVoucherTotal=0;//不参与优惠券金额
            let selectgoodsList: Array<any> = state.goodsList.filter(item => item.Checked);
            if(state.javaGoodNotVoucher.length>0){
                selectgoodsList = selectgoodsList.filter((item) => !state.javaGoodNotVoucher.some((items) => item.No === items));
                let canvoucherTotal=0;
                selectgoodsList.forEach((item) => {
                    if (item.Checked) {
                        canvoucherTotal += item.Price * item.Count;
                    }
                });
                javaGoodNotVoucherTotal=total-canvoucherTotal;
            }
            let obj: any = state.orderConfirmVoucher;
            if (obj) {
                if (obj.gifttypeflag == "1") {
                    let lessmoney: number = 0;
                    if (obj.itemlist) {
                        if (obj.itemlist.substr(0, 1) == "|") {
                            obj.itemlist = obj.itemlist.substr(1);
                        }
                        let strs: Array<any> = new Array();  // 定义一数组
                        strs = obj.itemlist.split("|"); // 字符分割

                        if (obj.typeflag == "3") {
                            // 单品折扣券
                            selectgoodsList.forEach(function (ele, i) {
                                for (let i = 0; i < strs.length; i++) {
                                    if (ele.No == strs[i]) {
                                        // 商品存在，就打折
                                        lessmoney = lessmoney + ele.Price * parseFloat((1 - obj.discountmoney / 10).toFixed(2)) * ele.Count;
                                    }
                                }
                            });
                        } else if (obj.typeflag == "1") {
                            // 类别折扣券
                            selectgoodsList.forEach(function (ele, i) {
                                for (let i = 0; i < strs.length; i++) {
                                    if (ele.TypeNo === strs[i] || ele.TopTypeNo === strs[i]) {
                                        // 类别存在，就打折
                                        lessmoney = lessmoney + ele.Price * parseFloat((1 - obj.discountmoney / 10).toFixed(2)) * ele.Count;
                                    }
                                }
                            });
                        }
                        _voucheramt = parseFloat(lessmoney.toFixed(2));
                    } else {
                        selectgoodsList.forEach(function (ele, i) {
                            lessmoney = lessmoney + ele.Price * parseFloat((1 - obj.discountmoney / 10).toFixed(2)) * ele.Count;

                        });
                        _voucheramt = parseFloat(lessmoney.toFixed(2));
                    }
                } else {
                    _voucheramt = obj.discountmoney ? obj.discountmoney * 1 : 0;
                }
                let _transFee = this.getters.transFee(state);
                if(javaGoodNotVoucherTotal>0){ //限时促销不使用优惠券金额
                    let canvoucheramt=total-javaGoodNotVoucherTotal-this.getters.favourablesum(state);
                    if ((_voucheramt >= canvoucheramt) && (_voucheramt>0)) {
                        if (_transFee != 0 || canvoucheramt>0) {
                            _voucheramt = canvoucheramt;
                        } else {
                            _voucheramt = canvoucheramt - 0.01;
                        }
                    }
                }else{
                    if (_voucheramt >= total) {
                        if (_transFee != 0) {
                            _voucheramt = total;
                        } else {
                            _voucheramt = total - 0.01;
                        }
                    }
                }
                if (_transFee) {
                    total += _transFee || 0;
                }
                if (state.scorecosts * 1 > 0) {
                    total -= state.scorecosts * 1;
                }
                //total -= state.voucheramt;
            } else if (state.morenVoucher) {
                _voucheramt -= state.morenVoucher.maxDiscountmoney;
            }
            return _voucheramt;
        },
        discountamt: (state) => {
            //return  state.voucheramt || 0;
            let _voucheramt = 0;
            let total = 0;
            if(state.marketOpenofflinediscount &&state.marketOpenofflinediscount.indexOf('4')>-1){
                total = this.getters.sum(state) -this.getters.notdiscountTotal(state);
            }else{
                total = this.getters.sum(state) -this.getters.notdiscountTotal(state);
            }
            //let obj: any = state.discountType;
            _voucheramt = total - total * state.discount;
            let _transFee = this.getters.transFee(state);
            if (_transFee) {
                total += _transFee || 0;
            }
            if (state.scorecosts * 1 > 0) {
                total -= state.scorecosts * 1;
            }
            if (_voucheramt >= total) {
                if (total == 0) {
                    _voucheramt = total;
                } else {
                    _voucheramt = total - 0.01;
                }
            }
            return _voucheramt;
        },
        discountamtCurrent: (state) => {
            //return  state.voucheramt || 0;
            let _voucheramt = 0;
            let total = 0;
            //判断预售
            if(state.currentActivity && state.currentActivity.activitiesclass == 4)
            {//预售
                if(state.marketOpenofflinediscount &&state.marketOpenofflinediscount.indexOf('3')>-1){
                    //预售打折
                    total = this.getters.currentsum(state);
                }else{
                    //预售不打折
                    total = 0;
                }
            }
            else{//非预售
                if(state.marketOpenofflinediscount &&state.marketOpenofflinediscount.indexOf('4')>-1){
                    total = this.getters.currentsum(state) -this.getters.notdiscountTotalCurrent(state);
                }else{
                    total = this.getters.currentsum(state) - this.getters.notdiscountTotalCurrent(state);
                }
            }
            //let total = this.getters.currentsum(state) - this.getters.favourablesumCurrent(state);
            //let obj: any = state.discountType;
            _voucheramt = total - total * state.discount;
            let _transFeeCurrent = this.getters.transFeeCurrent(state);
            if (_transFeeCurrent) {
                total += _transFeeCurrent || 0;
            }
            if (state.scorecosts * 1 > 0) {
                total -= state.scorecosts * 1;
            }
            if (_voucheramt >= total) {
                if (total == 0) {
                    _voucheramt = total;
                } else {
                    _voucheramt = total - 0.01;
                }
            }
            return _voucheramt;
        },
        transFee: (state) => {
            state.freightFlag = 0;
            let _transFee = 0;
            let goodlisttotal = this.getters.sum(state) - this.getters.favourablesum(state);
            if (state.discountType == 1) {//线下折扣,则不计算优惠券
                if(state.discount<1 && state.discount>0)
                {//实际支付金额考虑折扣情况
                    goodlisttotal = goodlisttotal* state.discount;
                }
            }
            if (state.orderman.dealtype == 1) {
                if (!state.orderFreight.is_freight_region) {   //按距离方案 0:按距离 1：按区域
                    let branchInfo = JSON.parse(sessionStorage.getItem("servicebranch")) || {};
                    //判断是否在区域内
                    let deliverRegion = state.freightDistances;
                    if (deliverRegion && deliverRegion.length > 0) {
                        let IsInRegion = true;
                        IsInRegion = Util.IsInRegionsQQ(state.orderman, deliverRegion, state.Bmap, state.BMapLib);
                        if (IsInRegion) {//在配送区域内
                            state.freightFlag = 0;
                        }
                        else {
                            state.freightFlag = -1;
                        }
                    }
                    let distance = 0;
                    if(state.orderFreight.freight_mode>0 && state.freightDistances>0){
                        distance=state.freightDistances
                    }else{
                        distance = Util.GetDistanceWithBaiDuGPSQQ(state.orderman.longitude, state.orderman.latitude, branchInfo.longitude, branchInfo.latitude, state.Bmap);
                    }
                    
                    if (distance) {
                        state.addDistance = <number>distance;
                    }
                    if (state.addDistance > state.orderFreight.freight_distance_out * 1000 && state.orderFreight.freight_distance_outopen) {
                        if (state.orderFreight.freight_type == "1") {
                            let _freight: number = 0;
                            if (state.addDistance > state.orderFreight.freight_distance_max * 1000) {
                                _freight = state.orderFreight.freight_distance_max_fee * 1;
                            } else if (state.addDistance > state.orderFreight.freight_distance_first * 1000 && state.addDistance <= state.orderFreight.freight_distance_max * 1000) {
                                let mol = Math.ceil((state.addDistance - state.orderFreight.freight_distance_first * 1000) / (state.orderFreight.freight_distance_extend * 1000));
                                _freight = (state.orderFreight.freight_distance_first_fee * 1) + mol * state.orderFreight.freight_distance_extend_fee;
                            } else {
                                _freight = state.orderFreight.freight_distance_first_fee;
                            }
                            _transFee = _freight;
                        } else if (state.orderFreight.freight_type == "0") {
                            _transFee = state.orderFreight.freight * 1;
                        }
                    } else if ((goodlisttotal >= state.orderFreight.freefreight * 1) && (state.orderFreight.freefreight > 0 || state.orderFreight.freefreight === 0)) {
                        _transFee = 0;
                    } else {
                        if (state.orderFreight.freight_type == "1") {
                            let _freight: number = 0;
                            if (state.addDistance > state.orderFreight.freight_distance_max * 1000) {
                                _freight = state.orderFreight.freight_distance_max_fee * 1;
                            } else if (state.addDistance > state.orderFreight.freight_distance_first * 1000 && state.addDistance <= state.orderFreight.freight_distance_max * 1000) {
                                let mol = Math.ceil((state.addDistance - state.orderFreight.freight_distance_first * 1000) / (state.orderFreight.freight_distance_extend * 1000));
                                _freight = (state.orderFreight.freight_distance_first_fee * 1) + mol * state.orderFreight.freight_distance_extend_fee;
                            } else {
                                _freight = state.orderFreight.freight_distance_first_fee;
                            }
                            _transFee = _freight;
                        } else if (state.orderFreight.freight_type == "0") {
                            _transFee = state.orderFreight.freight * 1;
                        }
                    }
                }
                else {//按区域方案
                    let goddsTotalWeight = this.getters.goddsTotalWeight(state);
                    let ordermancity = state.orderman.city;
                    if (!ordermancity) {
                        _transFee = 0;
                        state.freightFlag = -3;
                    }
                    else {
                        //当前城市所在生效的区域
                        let freightRegion = null;
                        state.freightRegions.forEach(el => {
                            let checkedRegion = el.checkedRegion;
                            if (checkedRegion.indexOf(ordermancity) > -1) {
                                freightRegion = el;
                                state.currentFreightRegion = freightRegion;
                                return false;
                            }
                        });
                        if (freightRegion) {//在区域内
                            _transFee = freightRegion.firstweightprice;
                            let addWeight = goddsTotalWeight - freightRegion.firstweight;
                            if (addWeight > 0) {
                                _transFee += Math.ceil(addWeight / freightRegion.secondweight) * freightRegion.secondweightprice;
                            }
                            if (freightRegion.islimit) {//计算是否限额
                                if (_transFee > freightRegion.limitprice) {
                                    _transFee = freightRegion.limitprice;
                                }
                            }
                            if (freightRegion.isfree) {
                                if (goodlisttotal >= freightRegion.freeprice) {
                                    _transFee = 0;
                                }
                            }
                        }
                        else {//不在区域内
                            _transFee = 0;
                            state.freightFlag = -1;
                        }
                    }
                }
            } else {
                _transFee = 0;
            }
            _transFee = _transFee || 0;
            return _transFee;
        },
        goddsNumber: (state) => {
            return state.goodsList.length;
        },
        goddsTotal: (state) => {
            let total = 0;
            if(state.goodsList) {
              state.goodsList.forEach((item) => {
                  if (item.Checked) {
                    total += item.Count;
                    //   if(item.buylimit!=null && item.Count>item.buylimit)
                    //   {
                    //        item.Count=item.buylimit;
                    //         total += item.buylimit;
                    //   }else{
                    //     total += item.Count;

                    //   }
                     
                  }
              });
            }
            return total;
        },
        voucheramtCurrent: (state) => {
            let _voucheramt = 0;
            let total = this.getters.currentsum(state) || 0;
            let selectgoodsList: Array<any> = state.currentGoodsList;
            let obj: any = state.orderConfirmVoucher;
            if (obj) {
                if (obj.gifttypeflag == "1") {
                    let lessmoney: number = 0;
                    if (obj.itemlist) {
                        if (obj.itemlist.substr(0, 1) == "|") {
                            obj.itemlist = obj.itemlist.substr(1);
                        }
                        let strs: Array<any> = new Array();  // 定义一数组
                        strs = obj.itemlist.split("|"); // 字符分割

                        if (obj.typeflag == "3") {
                            // 单品折扣券
                            selectgoodsList.forEach(function (ele, i) {
                                for (let i = 0; i < strs.length; i++) {
                                    if (ele.No == strs[i]) {
                                        // 商品存在，就打折
                                        lessmoney = lessmoney + ele.Price * parseFloat((1 - obj.discountmoney / 10).toFixed(2)) * ele.Count;
                                    }
                                }
                            });
                        } else if (obj.typeflag == "1") {
                            // 类别折扣券
                            selectgoodsList.forEach(function (ele, i) {
                                for (let i = 0; i < strs.length; i++) {
                                    if (ele.TypeNo === strs[i] || ele.TopTypeNo === strs[i]) {
                                        // 类别存在，就打折
                                        lessmoney = lessmoney + ele.Price * parseFloat((1 - obj.discountmoney / 10).toFixed(2)) * ele.Count;
                                    }
                                }
                            });
                        }
                        _voucheramt = parseFloat(lessmoney.toFixed(2));
                    } else {
                        selectgoodsList.forEach(function (ele, i) {
                            lessmoney = lessmoney + ele.Price * parseFloat((1 - obj.discountmoney / 10).toFixed(2)) * ele.Count;

                        });
                        _voucheramt = parseFloat(lessmoney.toFixed(2));
                    }
                } else {
                    _voucheramt = obj.discountmoney ? obj.discountmoney * 1 : 0;
                }
                let _transFeeCurrent = this.getters.transFeeCurrent(state);
                if (_voucheramt >= total) {
                    if (_transFeeCurrent != 0) {
                        _voucheramt = total;
                    } else {
                        _voucheramt = total - 0.01;
                    }
                }
                if (_transFeeCurrent) {
                    total += _transFeeCurrent || 0;
                }
                if (state.scorecosts * 1 > 0) {
                    total -= state.scorecosts * 1;
                }
                // if (_voucheramt >= total && total != 0) {
                //     if(this.getters.transFeeCurrent(state)!=0){
                //         _voucheramt = total;
                //     }else{
                //         _voucheramt = total - 0.01;
                //     }
                // }
                //total -= state.voucheramt;
            } else if (state.morenVoucher) {
                _voucheramt -= state.morenVoucher.maxDiscountmoney;
            }
            return _voucheramt;
        },
        transFeeCurrent: (state) => {
            state.freightFlag = 0;
            let _transFee = 0;
            let activityId = state.currentGoodsList.length == 0 ? null : state.currentGoodsList[0].ActivityId;
            let isSeckillGoods = state.currentGoodsList.length == 0 ? null : state.currentGoodsList[0].isSeckillGoods == true ? state.currentGoodsList[0].isSeckillGoods : null;
            let isUseFreight = state.currentActivity.isUseFreight;
            if (activityId != null && !isUseFreight && !isSeckillGoods) {//不开启运费直接返回运费0
                // if (activityId != null && !isUseFreight && !isSeckillGoods) {
                return _transFee;
            }
            let goodlisttotal = this.getters.currentsum(state) - this.getters.favourablesumCurrent(state);
            if (state.discountType == 1) {//线下折扣,则不计算优惠券
                if(state.discount<1 && state.discount>0)
                {//实际支付金额考虑折扣情况
                    goodlisttotal = goodlisttotal* state.discount;
                }
            }
            if (state.orderman.dealtype == 1) {
                if (!state.orderFreight.is_freight_region) { //按距离方案 
                    let branchInfo = JSON.parse(sessionStorage.getItem("servicebranch")) || {};
                    //判断是否在区域内
                    let deliverRegion = state.freightDistances;
                    if (deliverRegion && deliverRegion.length > 0) {
                        let IsInRegion = true;
                        IsInRegion = Util.IsInRegionsQQ(state.orderman, deliverRegion, state.Bmap, state.BMapLib);
                        if (IsInRegion) {//在配送区域内
                            state.freightFlag = 0;
                        }
                        else {
                            state.freightFlag = -1;
                        }
                    }
                    let distance = 0;
                    if(state.orderFreight.freight_mode>0 && state.freightDistances>0){
                        distance=state.freightDistances
                    }else{
                        distance = Util.GetDistanceWithBaiDuGPSQQ(state.orderman.longitude, state.orderman.latitude, branchInfo.longitude, branchInfo.latitude, state.Bmap);
                    }
                    if (distance) {
                        state.addDistance = <number>distance;
                    }
                    if (state.addDistance > state.orderFreight.freight_distance_out * 1000 && state.orderFreight.freight_distance_outopen) {//开启不包邮条件  超过距离
                        if (state.orderFreight.freight_type == "1") {//按距离
                            let _freight: number = 0;
                            if (state.addDistance > state.orderFreight.freight_distance_max * 1000) {
                                _freight = state.orderFreight.freight_distance_max_fee * 1;
                            } else if (state.addDistance > state.orderFreight.freight_distance_first * 1000 && state.addDistance <= state.orderFreight.freight_distance_max * 1000) {
                                let mol = Math.ceil((state.addDistance - state.orderFreight.freight_distance_first * 1000) / (state.orderFreight.freight_distance_extend * 1000));
                                _freight = (state.orderFreight.freight_distance_first_fee * 1) + mol * state.orderFreight.freight_distance_extend_fee;
                            } else {
                                _freight = state.orderFreight.freight_distance_first_fee;
                            }
                            _transFee = _freight;
                        } else if (state.orderFreight.freight_type == "0") {//固定运费
                            _transFee = state.orderFreight.freight * 1;
                        }
                    } else if ((goodlisttotal >= state.orderFreight.freefreight * 1) && (state.orderFreight.freefreight > 0 || state.orderFreight.freefreight === 0)) {
                        _transFee = 0;
                    } else {
                        if (state.orderFreight.freight_type == "1") {//运费按距离
                            let _freight: number = 0;
                            if (state.addDistance > state.orderFreight.freight_distance_max * 1000) {
                                _freight = state.orderFreight.freight_distance_max_fee * 1;
                            } else if (state.addDistance > state.orderFreight.freight_distance_first * 1000 && state.addDistance <= state.orderFreight.freight_distance_max * 1000) {
                                let mol = Math.ceil((state.addDistance - state.orderFreight.freight_distance_first * 1000) / (state.orderFreight.freight_distance_extend * 1000));
                                _freight = (state.orderFreight.freight_distance_first_fee * 1) + mol * state.orderFreight.freight_distance_extend_fee;
                            } else {
                                _freight = state.orderFreight.freight_distance_first_fee;
                            }
                            _transFee = _freight;
                        } else if (state.orderFreight.freight_type == "0") {//固定运费
                            _transFee = state.orderFreight.freight * 1;
                        }
                    }
                }
                else {//按区域方案
                    let goddsTotalWeight = this.getters.currentGoddsTotalWeight(state);
                    let ordermancity = state.orderman.city;
                    if (!ordermancity) {
                        _transFee = 0;
                        state.freightFlag = -3;
                    }
                    else {
                        //当前城市所在生效的区域
                        let freightRegion = null;
                        state.freightRegions.forEach(el => {
                            let checkedRegion = el.checkedRegion;
                            if (checkedRegion.indexOf(ordermancity) > -1) {
                                freightRegion = el;
                                state.currentFreightRegion = freightRegion;
                                return false;
                            }
                        });
                        if (freightRegion) {//在区域内
                            _transFee = freightRegion.firstweightprice;
                            let addWeight = goddsTotalWeight - freightRegion.firstweight;
                            if (addWeight > 0) {
                                _transFee += Math.ceil(addWeight / freightRegion.secondweight) * freightRegion.secondweightprice;
                            }
                            if (freightRegion.islimit) {//计算是否限额
                                if (_transFee > freightRegion.limitprice) {
                                    _transFee = freightRegion.limitprice;
                                }
                            }
                            if (freightRegion.isfree) {
                                if (goodlisttotal >= freightRegion.freeprice) {
                                    _transFee = 0;
                                }
                            }
                        }
                        else {//不在区域内
                            _transFee = 0;
                            state.freightFlag = -1;
                        }
                    }
                }
            } else {
                _transFee = 0;
            }
            _transFee = _transFee || 0;
            return _transFee;
        },
        favourablesumCurrent: (state) => {
            let total: number = 0;
            let selectgoodsList: Array<any> = state.currentGoodsList.filter(item => item.Checked);
            state.buyFullPromotionList.forEach((item) => {
                let groupfeetoatl: number = 0;
                let groupnumtoatl: number = 0;
                selectgoodsList.forEach((item2) => {
                    if (item.itemno.indexOf(item2.No) > -1) {
                        groupfeetoatl += item2.Price * item2.Count;
                        groupnumtoatl += item2.Count;
                    }
                });
                for (let i: number = 0; i < item.rules.length; i++) {
                    let rule: any = item.rules[i];
                    if ((rule.thresholdtype == "1" && groupfeetoatl >= rule.thresholdprice) ||
                        (rule.thresholdtype == "2" && groupnumtoatl >= rule.thresholdnum)) {
                        if (rule.isreduceprice) {
                            total += rule.reduceprice ? rule.reduceprice : 0;
                        }
                        break;
                    }
                }
            });
            let itemtotal = this.getters.currentsum(state) || 0;
            total = total >= itemtotal ? itemtotal : total;
            return total;
        },
        favourabletotalCurrent: (state) => {
            let total: number = 0;
            let selectgoodsList: Array<any> = state.currentGoodsList.filter(item => item.Checked);
            state.buyFullPromotionList.forEach((item) => {
                let groupfeetoatl: number = 0;
                let groupnumtoatl: number = 0;
                selectgoodsList.forEach((item2) => {
                    if (item.itemno.indexOf(item2.No) > -1) {
                        groupfeetoatl += item2.Price * item2.Count;
                        groupnumtoatl += item2.Count;
                    }
                });
                for (let i: number = 0; i < item.rules.length; i++) {
                    let rule: any = item.rules[i];
                    if ((rule.thresholdtype == "1" && groupfeetoatl >= rule.thresholdprice) ||
                        (rule.thresholdtype == "2" && groupnumtoatl >= rule.thresholdnum)) {
                            total += groupfeetoatl ? groupfeetoatl : 0;
                        break;
                    }
                }
            });
            let itemtotal = this.getters.currentsum(state) || 0;
            total = total >= itemtotal ? itemtotal : total;
            return total;
        },
        notdiscountTotalCurrent:(state)=>{
            ///折扣例外商品总价
            ///首先要判断例外商品是否在满减商品里，如果在则继续判断是否满减使用线下折扣，使用的话要把满减的金额减去，不使用的话则直接累加商品价格
            let total = 0;
            let buyFullTotal=0;
            let buyFullReduceTotal=0;
            let selectgoodsList: Array<any> = state.currentGoodsList.filter(item => item.Checked);
            let hasBuyFullItemnos=[];//满足满减条件的商品编号数组
            let notInItmenos=[];//不满足满减条件的商品编号数组
            state.buyFullPromotionList.forEach((item) => {
                let groupfeetoatl: number = 0;
                let groupnumtoatl: number = 0;
                selectgoodsList.forEach(item2 => {
                    if(item.itemno.indexOf(item2.No)>-1){
                        groupfeetoatl += item2.Price * item2.Count;
                        groupnumtoatl += item2.Count;
                        for (let i: number = 0; i < item.rules.length; i++) {
                            let rule: any = item.rules[i];
                            if ((rule.thresholdtype == "1" && groupfeetoatl >= rule.thresholdprice) ||
                                (rule.thresholdtype == "2" && groupnumtoatl >= rule.thresholdnum)) {
                                if (rule.isreduceprice) {
                                    buyFullReduceTotal += rule.reduceprice ? rule.reduceprice : 0;
                                }
                                buyFullTotal += groupfeetoatl ? groupfeetoatl : 0;
                                hasBuyFullItemnos.push(item2.No);
                                break;
                            }
                        }
                    }
                });
            });
            if(state.buyFullPromotionList.length==0 || hasBuyFullItemnos.length == 0){
                notInItmenos=state.goodsNotdiscount;
            }else{
                state.goodsNotdiscount.forEach(element => {
                    if((hasBuyFullItemnos.indexOf(element)==-1) && (notInItmenos.indexOf(element)==-1)){
                        notInItmenos.push(element)
                    }
                });
            }
            if(buyFullTotal>0){
                if(state.marketOpenofflinediscount &&state.marketOpenofflinediscount.indexOf('4')>-1){
                    total = buyFullReduceTotal;
                }else{
                    total = buyFullTotal;
                }
            }
            selectgoodsList.forEach((item2) => {
                if (notInItmenos.indexOf(item2.No) > -1) {
                    total += item2.Price * item2.Count;
                }
            });
            return total;
        },
        goddsTotalWeight: (state) => {
            let totalWeight = 0;
            state.goodsList.forEach((item) => {
                if (item.Checked) {
                    let goodsWeight = state.goodsWeight.filter(el => {
                        return el.no === item.No && el.activityId == item.activityId;
                    })
                    if (goodsWeight && goodsWeight.length > 0) {
                        if (goodsWeight[0].weight) {
                            totalWeight += goodsWeight[0].weight * item.Count;
                        }
                    }
                }
            });
            if (state.buyFullPromotionList.length > 0) {
                state.buyFullPromotionItems.forEach((item) => {
                    totalWeight += item.weight ? item.weight * item.Count : 0;
                });
            }
            return totalWeight;
        },
        currentGoddsTotalWeight: (state) => {
            let totalWeight = 0;
            state.currentGoodsList.forEach((item) => {
                if (item.Checked) {
                    let goodsWeight = state.goodsWeight.filter(el => {
                        return el.no === item.No && el.activityId == item.activityId;
                    })
                    if (goodsWeight && goodsWeight.length > 0) {
                        if (goodsWeight[0].weight) {
                            totalWeight += goodsWeight[0].weight * item.Count;
                        }
                    }
                }
            });
            if (state.buyFullPromotionList.length > 0) {
                state.buyFullPromotionItems.forEach((item) => {
                    totalWeight += item.weight ? item.weight * item.Count : 0;
                });
            }
            return totalWeight;
        },
        freightFlag: (state) => {
            return state.freightFlag;
        }
    };
    public actions = {
        async cartInformation(context: ActionContext<CartState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/MobileOrder/CartInformation', payload.data);
            context.state.buyFullPromotionList = reponse.data.result.buyFullPromotionDtoList;
            return reponse.data.result;
        },
        async getQQMapDistance(context: ActionContext<CartState, any>, payload: any) {
            const reponse = await Ajax.get(payload.data.url, payload.data);
            return reponse.data.result;
        },
    };
    public mutations = {
        addGoods: (state: { goodsList: any[]; }, data: any) => {
            let indexIn = -1
            state.goodsList.map((res, index) => {
              if(res.No == data.No && res.activityId == data.activityId) {
                indexIn = index
              }
            });
            if (indexIn > -1) {
                state.goodsList[indexIn]['Count'] += data.Count;
                state.goodsList[indexIn]['Checked'] = true;
            } else {
                state.goodsList.push(data);
            }
            // tslint:disable-next-line:quotemark
            const enshopid = Util.siss.auth.getenshopid();
            localStorage.setItem(enshopid + "_goodsList", JSON.stringify(state.goodsList));
        },
        deleteGoods(state, index) {
            state.goodsList.splice(index, 1);
            const enshopid = Util.siss.auth.getenshopid();
            localStorage.setItem(enshopid + '_goodsList', JSON.stringify(state.goodsList));
        },
        updateGoods(state, data) {
            const { index, key, value } = data;
            state.goodsList[index][key] = value;
            // console.log(index, key ,value)
            const enshopid = Util.siss.auth.getenshopid();
            localStorage.setItem(enshopid + '_goodsList', JSON.stringify(state.goodsList));
        },
        deleteAllGoods(state) {
            state.goodsList = [];
            const enshopid = Util.siss.auth.getenshopid();
            localStorage.removeItem(enshopid + '_goodsList');
        },
        updateorderdealtype(state, data) {
            state.orderman.dealtype = data.dealtype;
            const enshopid = Util.siss.auth.getenshopid();
            localStorage.setItem(enshopid + '_orderman', JSON.stringify(state.orderman));
        },
        // updateordermemo(state, data) {
        //     state.orderman.usermemo = data.usermemo;
        //     const enshopid=Util.siss.auth.getenshopid();
        //     localStorage.setItem(enshopid+'_orderman', JSON.stringify(state.orderman));
        // },
        updateorderuserinfo(state, data) {
            const enshopid = Util.siss.auth.getenshopid();
            const { orderman, ordertel, addressall, id, longitude, latitude, province, city } = data;
            state.orderman.orderman = orderman;
            state.orderman.ordertel = ordertel;
            state.orderman.addressall = addressall;
            state.orderman.id = id;
            state.orderman.longitude = longitude;
            state.orderman.latitude = latitude;
            state.orderman.province = province;
            state.orderman.city = city;
            localStorage.setItem(enshopid + '_orderman', JSON.stringify(state.orderman));
        },
        removeuserinfo(state) {
            state.orderman = {};
            const enshopid = Util.siss.auth.getenshopid();
            localStorage.removeItem(enshopid + '_orderman');
        },
        updatePintuanData(state, data) {
            const { parentno, pintuanid, itemno, num } = data;
            state.pintuanData.parentno = parentno;
            state.pintuanData.pintuanid = pintuanid;
            state.pintuanData.itemno = itemno;
            state.pintuanData.num = num;
        },
        updatepickupinstore(state, data) {
            const { branch_no, branch_name, addr, lng, lat, tel, isDefault, range, opentime, closedtime } = data;
            state.pickupinstore.branch_no = branch_no;
            state.pickupinstore.branch_name = branch_name;
            state.pickupinstore.addr = addr;
            state.pickupinstore.lng = lng;
            state.pickupinstore.lat = lat;
            state.pickupinstore.tel = tel;
            state.pickupinstore.isDefault = isDefault;
            state.pickupinstore.range = range;
            state.pickupinstore.opentime = opentime;
            state.pickupinstore.closedtime = closedtime;

            const enshopid = Util.siss.auth.getenshopid();
            localStorage.setItem(enshopid + '_orderConfirmBranch', JSON.stringify(state.pickupinstore));
        },
        removepickupinstore(state) {
            state.pickupinstore = {};
            const enshopid = Util.siss.auth.getenshopid();
            localStorage.removeItem(enshopid + '_orderConfirmBranch');
        },
        updateorderConfirmVoucher(state, data) {
            const { voucherid, type, discountmoney, isMax, gifttypeflag, itemlist, typeflag } = data;
            state.orderConfirmVoucher = {};
            state.orderConfirmVoucher.voucherid = voucherid;
            state.orderConfirmVoucher.type = type;
            state.orderConfirmVoucher.discountmoney = discountmoney;
            state.orderConfirmVoucher.isMax = isMax;
            state.orderConfirmVoucher.gifttypeflag = gifttypeflag;
            state.orderConfirmVoucher.itemlist = itemlist;
            state.orderConfirmVoucher.typeflag = typeflag;
            sessionStorage.setItem('orderConfirmVoucher', JSON.stringify(state.orderConfirmVoucher));
        },
        updatemorenVoucher(state, data) {
            const { voucherid, type, maxDiscountmoney, isMax } = data;
            state.morenVoucher = {}
            state.morenVoucher.voucherid = voucherid;
            state.morenVoucher.type = type;
            state.morenVoucher.maxDiscountmoney = maxDiscountmoney;
            state.morenVoucher.isMax = isMax;
        },
        updateFreight(state, data) {
            state.orderFreight = data;
            state.orderFreight.transFee = data.transFee || 0;
        },
        updateScoreCost(state, data) {
            const { type, cost } = data;
            if (type == 0) {
                state.scorecosts = cost;
            } else {
                state.scorecosts = 0;
            }
        },
        updateSelectScore(state, data) {
            const { type, score } = data;
            if (type == 0) {
                state.selectscore = score;
            } else {
                state.selectscore = 0;
            }
        },
        updateCurrentActivityType(state, data) {
            state.currentActivityType = data;
        },
        updateCurrentActivityDealDate(state, data) {
            state.currentActivityDealDate = data;
        },
        updatebuyFullPromotionList(state, data) {
            state.buyFullPromotionList = data;
        },
        updateMarketOpenofflinediscount(state, data){
            state.marketOpenofflinediscount=data;
        },
        refreshGoodsFromStorage(state) {
            let temp = state.goodsList.filter(item => !item.Checked);
            state.goodsList = temp;
            const enshopid = Util.siss.auth.getenshopid();
            localStorage.setItem(enshopid + '_goodsList', JSON.stringify(temp));
        },
        //清除停售和售罄商品
        clearGoodsFromStorage(state) {
            let temp = state.goodsList.filter(item => !item.cannot);
            state.goodsList = temp;
            const enshopid = Util.siss.auth.getenshopid();
            localStorage.setItem(enshopid + '_goodsList', JSON.stringify(temp));
        },
        refreshUsedVoucher(state) {
            state.morenVoucher = {};
            state.orderConfirmVoucher = {};
            sessionStorage.removeItem('orderConfirmVoucher');
        },
        updateDiscountType(state, data) {
            state.discountType = data;
            sessionStorage.setItem('discountType', data);
        },
        updateDiscount(state, data) {
            state.discount = data;
            sessionStorage.setItem('discount', data);
        },
        updateBmap(state, data) {
            state.Bmap = data;
        },
        updateOrdermemo(state, data) {
            state.ordermemo = data;
        },
        updateDealtime(state, data) {
            state.dealtime = data;
        },
        updateDealtimeText(state, data) {
            state.dealtime_text = data;
        },
        updateGoodWeight(state, data) {
            state.goodsWeight = data;
        },
        updateGoodNotdiscount(state, data) {
            state.goodsNotdiscount = data;
        },
        updateFreightRegions(state, data) {
            state.freightRegions = data;
        },
        updateFreightDistances(state, data) {
            state.freightDistances = data;
        },
        updateBMapLib(state, data) {
            state.BMapLib = data;
        },
        updatebuyFullPromotionItems(state, data) {
            state.buyFullPromotionItems = [];
            if (data.length > 0) {
                data.forEach(item => {
                    const { imageUrl, unit, name, oldPrice, count, weight } = item;
                    const temp = { ImageUrl: imageUrl, Unit: unit, Name: name, Price: 0, OldPrice: oldPrice, Count: count, weight: weight };
                    state.buyFullPromotionItems.push(temp)
                });
            }
        },
        updateJavaGoodNotVoucher(state, data) {
            state.javaGoodNotVoucher = data;
        },
        refreshcartstate(state,data) {
            if(!data){
                return;
            }
            state.goodsList = data;
        },
        //增加活动
        addAddPriceList(state, data) {
          state.addPriceList.push(data);
          const enshopid = Util.siss.auth.getenshopid();
          localStorage.setItem(enshopid + "_addPriceList", JSON.stringify(state.addPriceList));
        },
        //移除活动
        removeAddPrice(state) {
          let temp = state.goodsList.filter(item => item.Checked);
          temp.map(item => {
            let Index = state.addPriceList.findIndex(items => items.activityId == item.activityId);
            let TempObj = state.addPriceList.filter(items => items.activityId == item.activityId);
            TempObj.map(obj => {
              let nIndex = obj.normalGoods.findIndex(items => items.id == item.id)
              this.commit("removeAddPriceNormalList", {Index, nIndex})
            })
          })
        },
        //清除活动
        resetAddpriceList(state) {
          if(state.addPriceList && state.addPriceList.length > 0) {
            state.addPriceList.map((item, Index) => {
              if(item.normalGoods.length <= 0) {
                state.addPriceList.splice(Index, 1)
              }
            })
            const enshopid = Util.siss.auth.getenshopid();
            localStorage.setItem(enshopid + "_addPriceList", JSON.stringify(state.addPriceList));
          }
        },
        //活动增加普通商品
        addNewAddPriceNormalList(state, obj) {
          const { Index, data } = obj;
          state.addPriceList[Index].normalGoods.push(data);
          const enshopid = Util.siss.auth.getenshopid();
          localStorage.setItem(enshopid + "_addPriceList", JSON.stringify(state.addPriceList));
        },
        //活动增加加价购商品
        addNewAddPriceList(state, obj) {
          const { Index, data } = obj;
          state.addPriceList[Index].addPriceGoods.push(data);
          const enshopid = Util.siss.auth.getenshopid();
          localStorage.setItem(enshopid + "_addPriceList", JSON.stringify(state.addPriceList));
        },
        //活动移除普通商品
        removeAddPriceNormalList(state, obj) {
          const { Index, nIndex } = obj;
          state.addPriceList[Index].normalGoods.splice(nIndex, 1);
          //判断是否满足条件
          let addPrice = state.addPriceList[Index]
          let isTrue = Util.filterAddPriceActStatus(addPrice)
          if(!isTrue) {
            state.addPriceList[Index].addPriceGoods = []
          }
          if(state.addPriceList[Index].normalGoods.length == 0) {
            state.addPriceList.splice(Index, 1)
          }
          const enshopid = Util.siss.auth.getenshopid();
          localStorage.setItem(enshopid + "_addPriceList", JSON.stringify(state.addPriceList));
        },
        //活动移除加价购商品
        removeAddPriceList(state, obj) {
          const { Index, aIndex } = obj;
          state.addPriceList[Index].addPriceGoods.splice(aIndex, 1);
          if(state.addPriceList[Index].normalGoods.length == 0) {
            state.addPriceList.splice(Index, 1)
          }
          const enshopid = Util.siss.auth.getenshopid();
          localStorage.setItem(enshopid + "_addPriceList", JSON.stringify(state.addPriceList));
        },
        //活动更改普通商品
        updateAddPriceNormalList(state, obj) {
          const { Index, nIndex, data } = obj;
          state.addPriceList[Index].normalGoods[nIndex] = data;
          //判断是否满足条件
          let addPrice = state.addPriceList[Index]
          let isTrue = Util.filterAddPriceActStatus(addPrice)
          if(!isTrue) {
            state.addPriceList[Index].addPriceGoods = []
          }
          const enshopid = Util.siss.auth.getenshopid();
          localStorage.setItem(enshopid + "_addPriceList", JSON.stringify(state.addPriceList));
        }
    };
}

const cartModule = new CartModule();
export default cartModule;
